import React from "react";
import { ShieldCheck, HandCoins, FileSignature, Headphones, Handshake } from "lucide-react";
import { useLang } from "@/context/LangContext";

const icons = [FileSignature, HandCoins, Headphones, ShieldCheck];

export const WhoWeAre = () => {
  const { t } = useLang();
  const points = t("who.points");
  return (
    <section id="nosotros" data-testid="who-we-are-section" className="py-16 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#F5F7FB] border border-slate-200 px-4 py-1.5 rounded-full text-sm text-[#0B132B]">
              <Handshake size={16} className="text-[#E63946]" /> {t("who.badge")} 🇵🇱🇲🇽
            </div>
            <h2 className="font-head font-extrabold text-3xl md:text-5xl mt-5 leading-tight text-[#0B132B]">{t("who.title")}</h2>
            <div className="ej-accent-bar mt-4" />
            <p className="text-slate-600 mt-6">{t("who.p1")}</p>
            <p className="text-slate-600 mt-4">
              {t("who.p2pre")}<strong className="text-[#0B132B]">{t("who.p2strong")}</strong>{t("who.p2post")}
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {points.map((p, i) => {
              const Icon = icons[i] || ShieldCheck;
              return (
                <div key={i} className="bg-[#F5F7FB] rounded-2xl border border-slate-200 p-6 hover:border-[#FFD166] card-hover">
                  <Icon className="text-[#0B132B]" />
                  <div className="font-head font-bold text-lg mt-4 text-[#0B132B]">{p.t}</div>
                  <div className="text-sm text-slate-600 mt-1">{p.d}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
